import {
  useAnchorLinkScroll,
  useLayout,
  useTranslations,
  useOnScreen,
} from '@dustin-web/microsite-components/src/hooks'
import ArrowUpIcon from '@dustin-web/microsite-components/src/icon/generated/arrow-up'
import React from 'react'
import Link from 'next/link'

type Props = {
  productListForwardRef: React.RefObject<HTMLElement>
  filterForwardRef: React.RefObject<HTMLElement>
  totalResults: number
  idToScrollTo: string
}

export const ScrollToResults = ({
  productListForwardRef,
  filterForwardRef,
  totalResults,
  idToScrollTo,
}: Props) => {
  const { translate } = useTranslations()
  const { responsive, header } = useLayout()
  const productListInScreen = useOnScreen(
    productListForwardRef,
    `-${header.height.px.toString()}px`,
    undefined,
    true
  )
  const filterInScreen = useOnScreen(
    filterForwardRef,
    `-${header.height.px.toString()}px`,
    undefined,
    true
  )
  const { anchorOnClick } = useAnchorLinkScroll()

  // Don't show if filter is not visible
  if (!filterInScreen) return null

  // Don't show if product-list is visible or mobile
  if (productListInScreen || !responsive.breakpoints.min.MD || !totalResults) return null

  return (
    <div
      className="c-scroll-to-results u-sticky c-box u-box-shadow t-light-blue d-flex align-items-center u-w-100 a-pull-from-below u-mb-48"
      style={{ top: header.height.px + 20, transition: 'top .3s ease-out' }}>
      <ArrowUpIcon className="i-16 u-mr-12" />
      <Link
        prefetch={false}
        href="#"
        className="d-inline-block u-mr-8"
        onClick={anchorOnClick(idToScrollTo, -10)}>
        {translate('ShowResults')}
      </Link>
      {totalResults}{' '}
      {translate(totalResults > 1 ? 'ProductsMatchedYourChoice' : 'ProductMatchedYourChoice')}
    </div>
  )
}
